/*eslint disable*/

/*
This is a copy of app/assets/javascripts/mcm/menu.js and should always be kept in sync.
All this file changes is the constructor declaration, using an `export default` so it can be imported properly
Also there are some variables that aren't declared properly so we fix that:
- ~L216: var new_total=dollars * 100 + new_cents;
 */

//Menu = function Menu(menu_data,menu_id,tags_by_item_id,ratings_summary,price_multiplier) {
export default function Menu(options) {
  this.ID=options.menu_id;
  this.menuData = options.menu_data;
  this.lastID=0;
  this.tags_by_item_id=options.tags_by_item_id;
  this.ratings_summary=options.ratings_summary;
  this.extra_info=options.extra_info;
  this.price_multiplier=options.price_multiplier;
  this.raw=options.raw;

  //quick lookups -- so we can keep all the data in immediately serializable format, and allow easy api queries from other languages using the same data
  //note ids are unique accross object types -- isn't that handy?
  //TODO: seems like we could dispense with this complication if we had objects for each type with references where needed and .data properties so we can modify directly if desired -- although we still need to be able to lookup by id when request goes from client to server, so maybe not
  this.objectLookup={};
  this.parentOfObjectLookup={};
  if (!options.menu_data) {
    this.buildBasicObject();
    return;
  }
  //in theory we could do more automagically with this, but not worth the trouble now
  //this.relations={
    //menuData: ['sections','option_groups','sizes'],
    //sections: ['items'],
    //items: ['selections']
  //}

  if (!this.menuData.modifiers) //for backward compatibility
    this.menuData.modifiers=[];
  //create quick lookups and update lastID
  //TODO: this assumes either no ids or all ids (as indexing functions add ids if needed using nextID counter); could make this more robust

  //sections & items
  for (var i in this.menuData.sections) {
    var section=this.menuData.sections[i];
    this.indexObject(section,this.menuData);
    for (var j in section.items) {
      var item=section.items[j];
      if (!item.rprice)
        item.rprice=item.price;
      this.indexObject(item,section);
      this.convertItemModifiers(item);
    }
  }

  //option groups
  if (this.menuData.option_sets) {
    for (var i in this.menuData.option_sets) {
      var optionSet=this.menuData.option_sets[i];
      this.indexObject(optionSet,this.menuData);
      this.indexObjects(optionSet.options,optionSet);
    }
  }

  //modifiers
  if (this.menuData.modifiers)
    this.indexObjects(this.menuData.modifiers,this.menuData);

  //sizes
  if (this.menuData.sizes)
    this.indexObjects(this.menuData.sizes,this.menuData);
}

Menu.prototype.convertItemModifiers = function(item) { //for backward compatibility with non-shared modifiers (i.e. from eat24 crawl, since the conversion  script in ruby is hell to work with)
  if (!item.modifiers || !item.modifiers[0] || !(typeof item.modifiers[0]==='object'))
    return;
  var new_modifiers=[]; // will just be a list of modifier ids
  for (var i in item.modifiers) {
    var item_modifier=item.modifiers[i];
    var master_modifier=this.findMasterModifier(item_modifier);
    if (!master_modifier) {
      this.menuData.modifiers.push(item_modifier);
      this.indexObject(item_modifier,this.menuData);
      master_modifier=item_modifier;
    }
    new_modifiers.push(master_modifier.id);
  }
  item.modifiers=new_modifiers;
}

Menu.prototype.findMasterModifier = function(match_modifier) {
  for (var i in this.menuData.modifiers) {
    var modifier=this.menuData.modifiers[i];
    if (modifier.option_set_id==match_modifier.option_set_id &&
        modifier.free==match_modifier.free &&
        modifier.display==match_modifier.display &&
        modifier.max==match_modifier.max &&
        modifier.required==match_modifier.required)
      return modifier;
  }
  return null;
}

Menu.prototype.buildBasicObject = function() {
  menu_data={sections: [], sizes: [], option_sets: [], modifiers: []};
  this.menuData=menu_data;
}

//ORG: Indexing
Menu.prototype.lookupID = function(id) {
  return this.objectLookup[parseInt(id)];
}

Menu.prototype.lookupParentOfID = function(id) {
  return this.parentOfObjectLookup[parseInt(id)];
}

Menu.prototype.addIDIfNeeded = function(obj) {
  if (obj.id) {
    this.lastID=Math.max(obj.id,this.lastID);
  } else {
    obj.id=this.nextID();
  }
}

Menu.prototype.indexObject = function(obj,parentObject) {
  this.addIDIfNeeded(obj);
  this.objectLookup[obj.id]=obj;
  this.parentOfObjectLookup[obj.id]=parentObject;
}

Menu.prototype.indexObjects = function(objects,parentObject) {
  if (!objects) {
    return;
  }
  for (var i=0; i<objects.length; i++) {
    this.indexObject(objects[i],parentObject);
  }
}


//ORG: Misc

Menu.prototype.identifier = function() {
  return this.menuData.id;
}

Menu.prototype.itemForId = function(item_id) {
  return this.objectLookup[parseInt(item_id)];
}

Menu.prototype.indexOfItem = function(item) {
  var section=this.parentOfObjectLookup[item.id];
  return this.indexOfObjectInArray(item,section.items);
}

Menu.prototype.indexOfObjectInArray = function(obj,ary) {
  if (!ary) {
    return -1;
  }
  for (var i=0; i<ary.length;i++) {
    if (obj==ary[i]) {
      return i;
    }
  }
  return -1;
}
Menu.prototype.indexOfObjectInArrayWithAttrs = function(obj,ary,obj_attr,ary_attr) {
  if (!ary) {
    return -1;
  }
  for (var i=0; i<ary.length;i++) {
    if (obj[obj_attr]==ary[i][ary_attr]) {
      return i;
    }
  }
  return -1;
}

Menu.prototype.indexOfSize=function(item,size) {
  return this.indexOfObjectInArrayWithAttrs(size,item.prices,'id','size_id');
}

Menu.prototype.indexOfSizeInOptionsSet=function(size,option_set) {
  return this.indexOfObjectInArrayWithAttrs(size,option_set.prices,'id','size_id');
}

Menu.prototype.indexOfOptionInOptionsSet=function(option,option_set) {
  return this.indexOfObjectInArrayWithAttrs(option,option_set.options,'id','id');
}

Menu.prototype.indexOfModifier=function(item,modifier) {
  for (var i in item.modifiers) {
    var im=item.modifiers[i];
    if (im==modifier.id)
      return i;
  }
  return -1;
}

Menu.prototype.closestPrice=function(total_cents) {
  var cents = total_cents % 100;
  var new_cents;
  var dollars = Math.floor(total_cents / 100);
  var possible_cents=[0,25,50,75,95,100];
  for (var i in possible_cents) {
    var lower=possible_cents[i];
    var higher=possible_cents[parseInt(i)+1];
    var lower_delta=cents-lower;
    var higher_delta=higher-cents;
    if (lower_delta < 0 || higher_delta < 0) //not in this range
      continue;
    if (lower_delta < higher_delta)
      new_cents=lower;
    else
      new_cents=higher;
    var new_total=dollars * 100 + new_cents;
    return new_total;
  }
  return -1;
}

Menu.prototype.closestOptionPrice=function(total_cents) {
  var increased=total_cents*this.price_multiplier;
  var nickles=Math.round(increased/5);
  return nickles * 5;
}

//ORG: Editing

Menu.prototype.nextID = function() {
  this.lastID++;
  return this.lastID;
}

Menu.prototype.newItem = function(section) {
  var item={name: "", tax_code: "sales_tax"};
  this.indexObject(item,section);
  //TODO: make alphabetical?
  section.items.push(item);
  return item;
}

Menu.prototype.removeItem = function(item) {
  var section=this.lookupParentOfID(item.id) ;
  var idx=this.indexOfObjectInArray(item,section.items);
  section.items.splice(idx,1);
}

Menu.prototype.moveItem = function(item,newSectionID) {
  var oldSection=this.lookupParentOfID(item.id) ;
  var newSection=this.lookupID(newSectionID) ;
  if (newSection!=oldSection) {
    alert('moving')
    var idx=this.indexOfObjectInArray(item,oldSection.items);
    oldSection.items.splice(idx,1);
    newSection.items.push(item);
    this.indexObject(item,newSection);
  }
}


Menu.prototype.newSize = function(size) {
  this.indexObject(size,this.menuData);
  this.menuData.sizes.push(size);
  return size;
}

Menu.prototype.newSection = function(section) {
  this.indexObject(section,this.menuData);
  this.menuData.sections.push(section);
  return section;
}

Menu.prototype.removeSection = function(section) {
  var idx=this.indexOfObjectInArrayWithAttrs(section,this.menuData.sections,'id','id');
  this.menuData.sections.splice(idx,1);
}

Menu.prototype.removeItemSize = function(item,size) {
  var idx=this.indexOfSize(item,size);
  item.prices.splice(idx,1);
  if (item.prices.length==0) {
    delete item.prices;
  }
}

Menu.prototype.addItemSize = function(item,size,price) {
  var price={size_id: size.id, price: price};
  if (!item.prices) {
    item.prices=[price];
  } else {
    item.prices.push(price);
  }
}

Menu.prototype.removeModifierFromItem = function(item,modifier) {
  var idx=this.indexOfModifier(item,modifier) ;
  if (idx==-1)
    return;
  item.modifiers.splice(idx,1);
  if (item.modifiers.length==0) {
    delete item.modifiers;
  }
}

Menu.prototype.newModifierOnItem = function(option_set,item) {
  var modifier={};
  modifier.option_set_id=option_set.id;
  this.indexObject(modifier,this.menuData);
  this.menuData.modifiers.push(modifier);
  this.attachModifierToItem(modifier,item);
  return modifier;
}

Menu.prototype.attachModifierToItem = function(modifier,item) {
  if (item.modifiers) {
    item.modifiers.push(modifier.id);
  } else {
    item.modifiers=[(modifier.id)];
  }
}

Menu.prototype.removeOption = function(option) {
  var option_set=this.lookupParentOfID(option.id);
  var idx=this.indexOfOptionInOptionsSet(option,option_set);
  option_set.options.splice(idx,1);
}

Menu.prototype.newOption = function(option_set) {
  var option={};
  this.indexObject(option,option_set);
  option_set.options.push(option);
}

Menu.prototype.priceForSize = function(item,size) {
  var idx=this.indexOfSize(item,size);
  if (idx >-1) {
    var price=item.prices[idx];
    return price.price;
  }
  return 0;
}


Menu.prototype.removeUnusedSizes = function() {
//TODO
}

//TODO allow setting of index position in section
Menu.prototype.addItem = function(item,section_id) {
  var section=this.lookupID(section_id);
  this.indexObject(item,section)
  section.items.push(item);
  this.indexObjects(item.modifiers,item);
}


//TODO it may be safer to clone the item
Menu.prototype.updateItem = function(newItem,newSectionID) {
  var newSection=this.lookupID(newSectionID);
  var originalItem=this.lookupID(newItem.id);
  var originalSection=this.parentOfObjectLookup[newItem.id];
  var originalIndex=this.indexOfItem(originalItem);

  if (newSection==originalSection) {
    originalSection.items[originalIndex]=newItem;
  } else {
    originalSection.items.splice(originalIndex,1);
    newSection.push(newItem);
  }

  this.indexObject(newItem,newSection);
}

Menu.prototype.addOptionSet = function(newOptionSet) {
  if (!this.menuData.option_sets)
    this.menuData.option_sets=[];
  this.menuData.option_sets.push(newOptionSet);
  this.indexObject(newOptionSet,this.menuData);
  this.indexObjects(newOptionSet.options,newOptionSet);
}

Menu.prototype.newOptionSet = function() {
  var og={display: "Untitled", options: []};
  this.addOptionSet(og);
  return og;
}

Menu.prototype.updateOptionSet = function(newOptionSet) {
  var index=this.indexOfOptionSet(newOptionSet);
  this.menuData.option_sets[index]=newOptionSet;
  this.indexObject(newOptionSet,menuData);
  this.indexObjects(newOptionSet.options,newOptionSet);
}

//ORG: Text

Menu.prototype.optionNames = function(option_ids) {
  var names=[];
  if (option_ids) {
    for (var i=0; i<option_ids.length; i++) {
      names.push(this.optionName(option_ids[i]));
    }
  }
  return names;
}

Menu.prototype.optionName = function(option_id) {
  return this.lookupID(option_id).name;
}

Menu.prototype.sizeName = function(size_id) {
  if (!size_id)
    return;
  var name=null;
  if (this.lookupID(size_id))
    name=this.lookupID(size_id).name;
  return name;
}

Menu.prototype.itemName = function(item_id) {
  return this.lookupID(item_id).name;
}

Menu.prototype.itemDescription = function(item_id) {
  return this.lookupID(item_id).description;
}

Menu.prototype.itemImageSrc = function(item_id) {
  return this.lookupID(item_id).image_url;
}

Menu.prototype.itemRatings = function(item_id) {
  if (this.ratings_summary && this.ratings_summary[item_id]) {
    return this.ratings_summary[item_id];
  }
}

Menu.prototype.itemAverageRatingByUser = function (item_id, user_id) {
    var item_ratings = this.itemRatings(item_id);
    if (!item_ratings)
      return "-"

    var rating_count=0;
    var userRatingSum = item_ratings.ratings.reduce(function (acc, r) {
      if (r.user_id==user_id) {
        rating_count++;
        return acc + r.level;
      }
      return acc;
    }, 0);

    if (!rating_count)
      return "-";
    return (userRatingSum / rating_count).toFixed(3);
}

Menu.prototype.modifierDisplayText = function(modifier_id) {
  modifier=this.lookupID(modifier_id);
  if (!modifier || !modifier.option_set_id) {
    return '';
  }
  if (modifier.display) {
    return modifier.display;
  } else {
    optionSet=this.lookupID(modifier.option_set_id);
    if (optionSet.display) {
      return optionSet.display;
    } else {
      return "";
    }
  }
}

//ORG: Pricing
Menu.prototype.baseItemPrice = function(item_id,size_id,prefix) {
  var item=this.lookupID(item_id);
  if (item.prices) {
    for (var i=0; i< item.prices.length; i++) {
      var size_price=item.prices[i];
      if (size_price.size_id==size_id) {
        return (size_price[prefix + 'price'] ? size_price[prefix + 'price'] : size_price.price)
      }
    }
  } else {
      return (item[prefix + 'price'] ? item[prefix + 'price'] : item.price)
  }
  return 0;
}

//Menu.prototype.defaultPrice = function(item) {
Menu.prototype.defaultPrice = function(options) {
  if (!options.item)
    return null;
  var price=0;
  if (options.item.prices) {
    price=options.item.prices[0].price;
  } else if (options.item.price) {
    price=options.item.price;
  }
  if (options.adjusted && this.price_multiplier)
    return this.closestPrice(price*this.price_multiplier);
  return price;
}

//TODO: rprice does not allow for sizes.. probably move everything back to just 'price' since we are getting rid of markups
//TODO: now we have a *different kind* of markup (using adjusted flag). we should get rid of the old style markups as it is very confusing
//Menu.prototype.defaultRprice = function(item) {
Menu.prototype.defaultRprice = function(options) {
  if (options.item === undefined){
    return "";
  }
  if (this.price_multiplier && options.adjusted)
    return this.closestPrice(options.item.rprice*this.price_multiplier);
  return options.item.rprice;
}

//Menu.prototype.defaultPriceForOption = function(option_id,size_id) {
Menu.prototype.defaultPriceForOption = function(options) {
  var option=this.lookupID(parseInt(options.option_id));
  var optionSet=this.parentOfObjectLookup[parseInt(option.id)];
  if (option.prices) {
    for (var i=0; i<option.prices.length; i++) {
      if (option.prices[i].size_id==options.size_id) {
        var price=option.prices[i].price;
        if (options.adjusted && this.price_multiplier)
          return this.closestOptionPrice(price);
        return price;
      }
    }
  }
  if (option.price) {
    var price=option.price;
    if (options.adjusted && this.price_multiplier)
      return this.closestOptionPrice(price);
    return price;
  }
  if (optionSet.prices) {
    for (var i=0; i<optionSet.prices.length; i++) {
      if (optionSet.prices[i].size_id==options.size_id) {
        var price=optionSet.prices[i].price;
        if (options.adjusted && this.price_multiplier)
          return this.closestOptionPrice(price);
        return price;
      }
    }
  }
  if (optionSet.price) {
    var price=optionSet.price;
    if (options.adjusted && this.price_multiplier)
      return this.closestOptionPrice(price);
    return price;
  }
  return 0;
}

//Menu.prototype.priceForModifierWithOptionAndSize = function(modifier_id, option_id, size_id) {
Menu.prototype.priceForModifierWithOptionAndSize = function(options) {
  var modifier=this.lookupID(parseInt(options.modifier_id));
  var price;
  if (modifier.prices) {
    for (var i=0; i< modifier.prices.length; i++) {
      if (modifier.prices[i].size_id==options.size_id) {
        price=modifier.prices[i].price;
        break;
      }
    }
  } else if (modifier.price) {
    price=modifier.price;
  } else {
    price=this.defaultPriceForOption({option_id: options.option_id, size_id: options.size_id, adjusted: false}); //don't adjust here because we do it below
  }
  if (options.adjusted && this.price_multiplier) {
    var new_price=this.closestOptionPrice(price);
    return new_price;
  }
  return price;
}

//Menu.prototype.priceForModifierWithOptionsAndSize = function(modifier_id,option_ids, size_id) {
Menu.prototype.priceForModifierWithOptionsAndSize = function(options) {
  var total=0;
  if (options.option_ids) {
    for (var i=0; i<options.option_ids.length; i++) {
      total+=this.priceForModifierWithOptionAndSize({modifier_id: options.modifier_id, option_id: options.option_ids[i], size_id: options.size_id, adjusted: options.adjusted});
    }
  }
  return total;
}

Menu.prototype.selectionsAreValid = function(selections) {
  var modifier_ids=Object.keys(selections);
  for (var i=0; i< modifier_ids.length; i++) {
    var modifier_id=parseInt(modifier_ids[i]);
    if (!this.lookupID(modifier_id))
      return false;
    var option_ids=selections[modifier_id];
    for (var i=0; i<option_ids.length; i++) {
      var option_id=parseInt(option_ids[i]);
      if (!this.lookupID(option_id))
        return false;
    }
  }
  return true;
}

//Menu.prototype.priceForItemWithSizeAndSelections = function(item_id,size_id,selections_hash,prefix) {
// options = {item_id: , size_id: , selections_hash: , prefix: , adjusted: }
Menu.prototype.priceForItemWithSizeAndSelections = function(options) {
  var total=this.baseItemPrice(options.item_id,options.size_id,options.prefix);
  if (options.adjusted && this.price_multiplier)
    total=this.closestPrice(total*this.price_multiplier);
  var modifier_ids=Object.keys(options.selections_hash);
  for (var i=0; i< modifier_ids.length; i++) {
    var modifier_id=parseInt(modifier_ids[i]);
    var option_ids=options.selections_hash[modifier_id];
    total+=this.priceForModifierWithOptionsAndSize({modifier_id: modifier_id, option_ids: option_ids, size_id: options.size_id, adjusted: options.adjusted});
  }
  return total;
}

Menu.prototype.attributesDescriptionForOrderItem = function(item_id,quantity,size_id,selections_hash) {
  var desc=[];
  //if (size_id)
    //desc.push({Size: this.sizeName(size_id)});
  for (var selection_id in selections_hash) {
    var choice_ids=selections_hash[selection_id];
    if (!choice_ids || choice_ids.length == 0)
      continue;
    var displayText=this.modifierDisplayText(selection_id);
    var optionNames=this.optionNames(choice_ids);
    var hash={};
    hash[displayText]=optionNames.join(', ');
    desc.push(hash);
  }
  return desc;
}

Menu.prototype.tagsForItem = function(item) {
  return this.tags_by_item_id[item.id];
}

//ORG: utility

Menu.prototype.modifierMaxOptions = function(modifier) {
  if (modifier.max) {
    return modifier.max;
  } else {
    var optionSet=this.optionSetForModifier(modifier) ;
    if (optionSet.max) {
      return optionSet.max;
    }
  }
  return 0;
}

Menu.prototype.defaultSelectionsHash = function(item_id) {
  var selectionsHash={};
  var item=this.lookupID(item_id);
  for (var i in item.modifiers) {
    var modifier_id=item.modifiers[i];
    var modifier=this.lookupID(modifier_id);
    if (modifier.required) {
      var optionSet=this.optionSetForModifier(modifier);
      selectionsHash[modifier.id]=[parseInt(optionSet.options[0].id)];
    }
  }
  return selectionsHash;
}

Menu.prototype.defaultSelectionsHashBasedOnFreq = function(item_id,ingredient_frequencies, dislikes) {
  var selectionsHash={};
  var warnings=[];
  var item=this.lookupID(item_id);
  var ingredients_contradict_dislikes=false;
  for (var i in item.modifiers) {
    var modifier_id=item.modifiers[i];
    var modifier=this.lookupID(modifier_id);
    if (modifier.required) {
      var optionSet=this.optionSetForModifier(modifier);
      //find first option without any forbidden ingredients
      for (var j in optionSet.options) {
        var option=optionSet.options[j];

        //check to see if option contains any forbidden ingredients
        var ingredients_are_ok=true;
        for (var k in option.ingredients) {
          var ingredient=option.ingredients[k]
          for (var l in dislikes) {
            var dislike=dislikes[l];
            if (dislike==ingredient)
              ingredients_contradict_dislikes=true;
          }
          for (var forbidden_ingredient in ingredient_frequencies) {
            var freq=ingredient_frequencies[forbidden_ingredient];
            if (freq!='never')
              continue;
            if (ingredient==forbidden_ingredient)
              ingredients_are_ok=false;
          }
        }
        if (ingredients_are_ok) {
          if (!selectionsHash[modifier.id])
            selectionsHash[modifier.id]=[];
          selectionsHash[modifier.id].push(parseInt(option.id));
          if (modifier.min && modifier.min > 1) {
            if (selectionsHash[modifier.id].length >= modifier.min)
              break;
          } else {
            break; //since we found a suitable option
          }
        }
      }
      if (!selectionsHash[modifier.id] || selectionsHash[modifier.id].length < modifier.min) {
        warnings.push('unable_to_select_all_required_options');
      } //DEV-201
    }
  }
  if (ingredients_contradict_dislikes)
    warnings.push('option_ingredients_contradict_dislikes');
  return JSON.stringify({warnings: warnings, selections_hash: selectionsHash});
}

Menu.prototype.optionSetForModifier = function(s) {
  return this.lookupID(s.option_set_id);
}

Menu.prototype.optionSetForModifierID = function(mid) {
  var modifier=this.lookupID(mid);
  return this.lookupID(modifier.option_set_id);
}

//TODO: put this in a helper class
Menu.prototype.formatCents = function(cents) {
  if (!cents) {
    cents=0;
  }
  return (cents/100.0).toFixed(2);
}
